
import PropTypes from 'prop-types';
import { TableRow, TableCell} from "@mui/material";


export default function FindCourseTableRow({
    row, selected, onSelectRow, onClose, onEditRow, onViewRow, formId, onArchive, onComplete, onCancelled, revertInProgress
}){

    const { courseTitle } = row;

 return (
    <>
    <TableRow hover selected={selected}>

           <TableCell  sx={{whiteSpace: 'nowrap'}} onClick={() => {
            onSelectRow();
            onClose();
           }}>{courseTitle}</TableCell>

    </TableRow>
</>
 )

}

FindCourseTableRow.propTypes = {
    onEditRow: PropTypes.func,
    onViewRow: PropTypes.func,
    onArchive: PropTypes.func,
    onComplete: PropTypes.func,
    onCancelled: PropTypes.func,
    revertInProgress: PropTypes.func,
  };
  